import UtilsFormule from "../../../utils/UtilsFormule";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useState } from "react";
import { Alert, Snackbar } from "@mui/material";

const DataTableListPromoDetails=({listPromoCaisse})=>{


  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);


  const { SearchBar } = Search;

  function handleTableChange({ products }) {
    return products;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };
  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };
  
  function type(cell, row) {
    if(row.type==="PERCENT"){
      return <span>Pourcentage</span>;

    }else if(row.type==="Amount"){
      return <span>Montant</span>;

    }
  }
 

  // Define columns based on available fields
  const columns = [
    {
      dataField: "type",
      text: "type",
      formatter: type,

      headerStyle: { width: "20%" },
    },
    {
      dataField: "value",
      text: "Valeur",
      align: "center",
      headerAlign: "center",
      headerStyle: { width: "15%" },
    }
  ];


  return (
    <section class="content">
      <div class="card">
        <div class="card-header  ">
          <h3 class="card-title">Les Promos </h3>
          <div class="card-tools">
            <button
              type="button"
              class="btn btn-tool"
              data-card-widget="collapse"
              title="Collapse"
            >
              <i class="fas fa-minus"></i>
            </button>
          </div>
        </div>
        <div class="card-body ">
          <ToolkitProvider
            keyField="id"
            data={listPromoCaisse}
            columns={columns}
            onTableChange={handleTableChange}
            exportCSV
            search
          >
            {(props) => (
              <div>
                <div className="row ml-0">
                  <div>
                    <SearchBar
                      {...props.searchProps}
                      className="custome-search-field"
                      style={{ color: "black" }}
                      placeholder="Chercher"
                    ></SearchBar>
                  </div>
                  <div className="ml-auto mr-0">
                    <MyExportCSV {...props.csvProps}></MyExportCSV>
                  </div>
                </div>
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                />
              </div>
            )}
          </ToolkitProvider>
          {openInfoAlert && (
            <Snackbar
              open={openInfoAlert}
              autoHideDuration={2000}
              onClose={handleInfoClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
              <Alert variant="filled" onClose={handleInfoClose} severity="info">
                {infoAlertText}
              </Alert>
            </Snackbar>
          )}
        </div>
      </div>
    </section>
  );

}
export default DataTableListPromoDetails;